/**
 * Where a department listing entry links to. Reports and utilities share the
 * listing (`docs/UTILITIES.md` §3) and differ only in the route segment.
 */

import type { ReportSummary } from './types'

export function itemPath(department: string, item: Pick<ReportSummary, 'slug' | 'kind'>): string {
  const segment = item.kind === 'utility' ? 'u' : 'r'
  return `/d/${department}/${segment}/${item.slug}`
}
